import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { FiChevronDown } from 'react-icons/fi';
import './StaticPages.css';

const faqs = [
  {
    category: 'Orders & Shipping',
    items: [
      { q: 'How long does delivery take?', a: 'Standard delivery takes 5-7 business days. Express delivery is available for select pin codes and takes 2-3 business days.' },
      { q: 'Do you offer free shipping?', a: 'Yes! We offer free shipping on all orders above ₹999. For orders below ₹999, a flat shipping fee of ₹79 applies.' },
      { q: 'Can I track my order?', a: 'Absolutely! Once your order ships, you\'ll receive a tracking link via email and SMS. You can also track your order from the "My Orders" section in your account.' },
      { q: 'Do you ship internationally?', a: 'Currently, we ship only within India. We\'re working on expanding to international markets soon!' },
    ],
  },
  {
    category: 'Returns & Exchanges',
    items: [
      { q: 'What is your return policy?', a: 'We offer a hassle-free 15-day return policy. If you\'re not satisfied with your purchase, you can initiate a return from your account within 15 days of delivery.' },
      { q: 'How do I exchange a product?', a: 'To exchange an item, simply initiate a return and place a new order for the desired size or product. We\'ll process your refund as soon as we receive the returned item.' },
      { q: 'When will I get my refund?', a: 'Refunds are processed within 5-7 business days after we receive and inspect the returned item. The amount will be credited back to your original payment method.' },
      { q: 'Can I return sale items?', a: 'Items purchased during sales or with promotional discounts can be returned within the same 15-day window, provided they meet our return conditions.' },
    ],
  },
  {
    category: 'Products & Sizing',
    items: [
      { q: 'How do I find the right size for my child?', a: 'Each product page includes a detailed size chart with measurements. We recommend measuring your child and comparing with the chart for the best fit.' },
      { q: 'Are your fabrics safe for sensitive skin?', a: 'Yes! All our fabrics are tested for safety and are free from harmful chemicals. We use soft, breathable materials that are gentle on sensitive skin.' },
      { q: 'Do you have seasonal collections?', a: 'We launch new collections every season — Spring/Summer and Autumn/Winter. We also drop limited-edition capsule collections throughout the year.' },
    ],
  },
  {
    category: 'Payment & Account',
    items: [
      { q: 'What payment methods do you accept?', a: 'We accept credit/debit cards (Visa, Mastercard, RuPay), UPI, net banking, and popular wallets like Paytm and PhonePe. Cash on Delivery is also available for select pin codes.' },
      { q: 'Is it safe to pay online?', a: 'Absolutely. All transactions are secured with 256-bit SSL encryption. We never store your card details on our servers.' },
      { q: 'How do I create an account?', a: 'Click on the user icon in the top navigation bar and select "Register". You can sign up with your email address and start shopping in seconds.' },
    ],
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => setOpenIndex(openIndex === idx ? null : idx);

  let globalIdx = 0;

  return (
    <div className="static-page">
      <Helmet><title>FAQ - MiniMom Co</title></Helmet>
      <div className="static-page-header">
        <h1>Frequently Asked Questions</h1>
        <p>Got questions? We've got answers.</p>
      </div>
      <div className="static-page-content">
        {faqs.map((section) => (
          <section key={section.category} className="static-section">
            <h2>{section.category}</h2>
            <div className="faq-list">
              {section.items.map((item) => {
                const idx = globalIdx++;
                return (
                  <div key={idx} className={`faq-item ${openIndex === idx ? 'open' : ''}`}>
                    <button className="faq-question" onClick={() => toggle(idx)}>
                      <span>{item.q}</span>
                      <FiChevronDown className="faq-icon" />
                    </button>
                    <div className="faq-answer">
                      <p>{item.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
